<template>
  <div class="comment-complete">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('contacts.comment.form_completed.title') }}
        </p>
      </div>
      <div class="main">
        <p class="message">
          {{ $t('contacts.comment.form_completed.message') }}
        </p>
      </div>
      <div class="footer">
        <el-button type="primary" @click="handleClose" class="btn btn-back">
          {{ $t('contacts.comment.form_completed.btn_back') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      openPopupSendMessgeComplete: { type: Boolean, required: true, default: false },
    },
    emits: ['closePopupSendMessageComplete'],
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    methods: {
      handleClose() {
        this.$emit('closePopupSendMessageComplete');
      },
    },
    created() {
      this.dialog = this.openPopupSendMessgeComplete;
    }
  }
</script>

<style lang="scss" scoped>
  .comment-complete {
    text-align: center !important;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700
    }
    .main {
        letter-spacing: 0.75px;
        color: #000000;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
    }
    .footer {
        margin-top: 30px;
       padding-bottom: 50px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
      }
      .btn-back {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
    }
  }
</style>
